import { render } from "./NoticeWarning.vue?vue&type=template&id=ef0c79de"
import script from "./NoticeWarning.vue?vue&type=script&lang=js"
export * from "./NoticeWarning.vue?vue&type=script&lang=js"

import "./NoticeWarning.vue?vue&type=style&index=0&id=ef0c79de&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__